export const pageSizeOptions: ISelectOption<number>[] = [
    {
        value: 10,
        label: '10 per page',
    },
    {
        value: 25,
        label: '25 per page',
    },
    {
        value: 50,
        label: '50 per page',
    },
];
